import React from "react";
import {
  Route,
  Switch,
  Redirect
  // RouteComponentProps,
} from "react-router";
import { connect } from "react-redux";

import { IRootState } from "reducers";
import { USER_ROLES } from "enums/userRoles";
import Header from "components/Header";
import Footer from "components/Footer";

import NewsPage from "pages/NewsPage";
import ProfilePage from "pages/ProfilePage";
import NotificationsPage from "pages/NotificationsPage";
import VinCheck from "pages/VinCheck";
import CardPage from "pages/CardPage";
import CartPage from "pages/CartPage";
import CatalogPage from "pages/CatalogPage";
import DashboardPage from 'pages/DashboardPage';
import ReferalProgram from "pages/ReferalProgramPage";
import AnalayticsPage from "pages/AnalayticsPage";
// import IntroPage from "pages/IntroPage";

const HomePage: React.SFC<any> = ({ match, user }) => (
  <React.Fragment>
    <Header />
    <Switch>
      <Redirect exact={true} from={`${match.url}`} to={`${match.url}/dashboard`} />
      <Route path={`${match.url}/news/page/:page([0-9]+)`} component={NewsPage} />
      <Redirect from={`${match.url}/news`} to={`${match.url}/news/page/0`} />

      <Route path={`${match.url}/catalog/page/:page([0-9]+)`} component={CatalogPage} />
      <Redirect from={`${match.url}/catalog`} to={`${match.url}/catalog/page/0`} />

      <Route path={`${match.url}/profile`} component={ProfilePage} />
      <Route path={`${match.url}/notifications`} component={NotificationsPage}/>
      { user.role_id === USER_ROLES.CAR_AGENT
        ? <Route path={`${match.url}/vin`} component={VinCheck} />
        : null
      }
      <Route path={`${match.url}/dashboard`} component={DashboardPage} />
      <Route path={`${match.url}/cart`} component={CartPage} />
      <Route path={`${match.url}/referal`} component={ReferalProgram} />
      <Route path={`${match.url}/analytics`} component={AnalayticsPage} />
      {/* <Route path={`${match.url}/intro`} component={IntroPage} /> */}

      <Route path={`${match.url}/card/:id([0-9]+)`} component={CardPage} />
    </Switch>
    <Footer />
  </React.Fragment>
);

const mapStateToProps = ({ user }: IRootState) => ({
  user
});

export default connect(mapStateToProps)(HomePage);
